export const en_us = {
  validation_error: 'This field is required.',
  all: 'All',
  filter_result_text: 'SHOWING',
  filter_msg_title: 'No results found.',
  filter_msg: "We couldn't find what you searching for. Try searching again.",
};
